/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FORWARD_PROPERTY, NUMBER_TYPES, VMAIL_PROPERTY } from '../../lib/constants';
import ConfirmationModal from '../ConfirmationModal';

function findSelectedType(type, defaultTypes) {
  if (!type) {
    return defaultTypes[0];
  }
  return defaultTypes.find(numberType => numberType?.value === type);
}

class NumberTypeSelect extends Component {
  constructor(props) {
    super(props);
    this.NUMBER_TYPES =
      props.comingFrom !== 'number'
        ? NUMBER_TYPES
        : [...NUMBER_TYPES, /* FORWARD_PROPERTY,*/ VMAIL_PROPERTY];
    this.state = {
      dropdownOpen: false,
      selectedType: findSelectedType(props.selectedType, this.NUMBER_TYPES),
      dropdownList: this.NUMBER_TYPES,
      confirmModalStatus: false
    };
  }

  componentDidMount() {
    const { selectedType, dropdownList } = this.state;
    const { box } = this.props;
    this.onTypeSelect(selectedType);
    if (!box?.enhancedFax) {
      const updatedList = dropdownList.map(numberType => {
        if (numberType?.value === 'faxStandard') {
          return { ...numberType, active: false };
        }
        return numberType;
      });
      this.setState({ dropdownList: updatedList });
    }
  }

  componentDidUpdate(prevProps) {
    const { dropdownList } = this.state;
    if (this.props.selectedType !== prevProps.selectedType) {
      this.setState({ selectedType: findSelectedType(this.props.selectedType, dropdownList) });
    }
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onTypeSelect = numberType => {
    const { onTypeSelect, e911Enabled, boxDetails, comingFrom } = this.props;
    if (
      !boxDetails?.myEpik &&
      !e911Enabled &&
      (numberType?.value === 'vmail' || numberType?.value === 'voice') &&
      comingFrom !== 'number'
    ) {
      toast.error('E911 must be enabled prior to assigning a voice line on the port');
    } else {
      if (numberType?.value === 'fax') {
        this.setState({ confirmModalStatus: true });
      } else if (numberType?.active) {
        this.setState({
          selectedType: numberType,
        });
        onTypeSelect(numberType);
      } else {
        toast.error(
          'Enhanced Fax is required for T.38. Please enable Enhanced Fax from the Options Menu.',
        );
      }
    }
  };

  simplifiedString = (label) => (label?.split('(')[0]?.trim() || "")?.replace(/\s+/g, "_")?.replace(/_-_/g, "_")?.toLowerCase();

  renderTypes = () => {
    const { dropdownList } = this.state;
    let selectedType = this.props.selectedType
      ? findSelectedType(this.props.selectedType, dropdownList)
      : this.state.selectedType;
    return dropdownList
      .filter(numberType => numberType?.value !== selectedType?.value)
      .map(numberType => {
        return (
          <DropdownItem
            style={{ backgroundColor: !numberType?.active ? '#ccc' : null }}
            key={numberType?.value}
            id={this.simplifiedString(numberType?.label)}
            onClick={() => this.onTypeSelect(numberType)}
          >
            {numberType.label}
          </DropdownItem>
        );
      });
  };

  render() {
    const { selectedType, dropdownOpen, dropdownList, confirmModalStatus } = this.state;
    const { disabledAdmin, className, toggleClassName } = this.props;
    return (
      <>
      <Dropdown className={className} name="type" isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle className={toggleClassName} id={this.simplifiedString(selectedType?.label)} disabled={disabledAdmin || false} caret>
          {this.props.selectedType
            ? findSelectedType(this.props.selectedType, dropdownList)?.label
            : selectedType?.label}
        </DropdownToggle>
        <DropdownMenu>{this.renderTypes()}</DropdownMenu>
      </Dropdown>
        <ConfirmationModal
          isOpen={confirmModalStatus}
          onCancel={() => { this.setState({ confirmModalStatus: false, selectedType }); }}
          bodyText={"Fax Relay Protocol (T.37) should only be used in high volume Faxing scenarios. Are you sure you want to proceed?"}
          onConfirm={() => {
            this.setState({
              confirmModalStatus: false,
              selectedType: findSelectedType('fax', dropdownList)
            }, () => this.props.onTypeSelect(this.state.selectedType));
          }}
          headerText={"Attention"}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  box: state.AppState.boxDetails.box,
});

export default connect(
  mapStateToProps,
  null,
)(NumberTypeSelect);
